export default __webpack_public_path__ + "static/subscription-journey-integration-782dd6769be9decb1160d2a9cd87298c.svg";